import { SiteToolScope } from "#app/sites/site-tool-scope";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { CapabilityGate } from "../../../components/capability-gate";

export const Route = createFileRoute("/_protected/site-tools/_layout")({
  component: SiteToolsLayout,
});

/**
 * 建站工具布局（redesign v3）：能力门禁 + 内容区。
 * Hub 即首页，不再保留二级标签导航；AI 设置入口在 ACF 页头部。
 */
function SiteToolsLayout() {
  return (
    <CapabilityGate capability="site-tools">
      <div className="min-h-screen bg-background">
        <SiteToolScope home="/site-tools">
          <Outlet />
        </SiteToolScope>
      </div>
    </CapabilityGate>
  );
}
